const env = {
  appName:      import.meta.env.VITE_APP_NAME      ?? 'MyApp',
  appVersion:   import.meta.env.VITE_APP_VERSION   ?? '1.0.0',
  apiBaseUrl:   import.meta.env.VITE_API_BASE_URL  ?? 'http://localhost:8080/api',
  apiTimeout:   Number(import.meta.env.VITE_API_TIMEOUT ?? 30000),
  appEnv:       import.meta.env.VITE_APP_ENV       ?? 'development',
  // In dev, '' = same origin (localhost:3000) so Vite proxies /socket.io to the backend.
  socketOrigin: (import.meta.env.VITE_SOCKET_ORIGIN as string | undefined)
    ?? (import.meta.env.DEV ? '' : window.location.origin),
  isDev:  import.meta.env.DEV,
  isProd: import.meta.env.PROD,
} as const;

export default env;
